/** @jsx jsx */

import { Select, SelectItem } from '@zapier/design-system';
import { jsx, css } from '@emotion/core';

type SelectableItem = {
  label: string;
  value: string;
};

type PartnerEmbedDropdownProps<T extends SelectableItem> = {
  items: T[];
  initialSelectedItem: T;
  onSelect: (value: T['value']) => void;
};

const styleRoot = css`
  min-width: 320px;
`;

export default function PartnerEmbedDropdown<T extends SelectableItem>({
  initialSelectedItem,
  items,
  onSelect,
}: PartnerEmbedDropdownProps<T>) {
  return (
    <div css={styleRoot} data-testid="PartnerEmbedTypeDropDown">
      <Select
        defaultSelectedKey={initialSelectedItem.value}
        isLabelHidden={true}
        label="Embed type"
        onChange={key => {
          onSelect(key as T['value']);
        }}
        placeholder="Choose an embed type..."
      >
        {items.map(item => (
          <SelectItem key={item.value} value={item.value}>
            {item.label}
          </SelectItem>
        ))}
      </Select>
    </div>
  );
}
